import { ICellRendererParams } from 'ag-grid-community'

import { useQuickFilterHighlights } from '@/lib/ui/quick-filter-highlights.hook'

import type { ControlRow } from '@/pages/control/ag-grid-control/types'

import { HighlightedText } from '@/components/lemmala-design-system/highlighted-text/highlighted-text'

export const ControlTitleCell = ({ data }: ICellRendererParams<ControlRow>) => {
  const { getHighlights } = useQuickFilterHighlights()

  if (!data) return null

  const { categoryName, title } = data

  return (
    <div className='flex flex-col gap-1'>
      <div className='text-main-foreground-tertiary text-body-small'>{categoryName}</div>
      <div className='font-medium text-main-foreground-primary text-body-default'>
        <HighlightedText text={title || ''} highlights={getHighlights(title || '')} />
      </div>
    </div>
  )
}
